module.exports = __webpack_public_path__ + "img/layout.0d0e197f.png";